import { usdtToken } from '@shared/data/token'
import { Network, CosmosChainIds } from '@shared/types'
import {
  TokenType,
  TokenSource,
  TokenVerification
} from '@injectivelabs/sdk-ts/types'
import type { TokenStatic } from '@injectivelabs/sdk-ts'

export const allowanceResetSymbols = ['USDT']
export const ethAllowanceResetTokenAddresses = [usdtToken.address]

export const ETH_SYMBOL_WAIVED_BRIDGE_FEE = [
  'ETHBTCTrend',
  'SteadyETH',
  'SteadyBTC'
]

export const legacyWHDenoms = [
  'factory/inj14ejqjyq8um4p3xfqj74yld5waqljf88f9eneuk/inj1q6zlut7gtkzknkk773jecujwsdkgq882akqksk', // 'USDCet'
  'factory/inj14ejqjyq8um4p3xfqj74yld5waqljf88f9eneuk/inj1sthrn5ep8ls5vzz8f9gp89khhmedahhdkqa8z3', // 'SOLlegacy'
  'factory/inj14ejqjyq8um4p3xfqj74yld5waqljf88f9eneuk/inj1d5vz0uzwlpfvgwrwulxg6syy82axa58y4fuszd', // 'ARBlegacy'
  'factory/inj14ejqjyq8um4p3xfqj74yld5waqljf88f9eneuk/inj1tjcf9497fwmrnk22jfu5hsdq82qshga54ajvzy', // 'PYTHlegacy'
  'factory/inj14ejqjyq8um4p3xfqj74yld5waqljf88f9eneuk/inj1dxv423h8ygzgxmxnvrf33ws3k94aedfdevxd8h' // 'WMATIClegacy
]

export const neokTokenMeta = {
  address:
    'ibc/F6CC233E5C0EA36B1F74AB1AF98471A2D6A80E2542856639703E908B4D93E7C4',
  isNative: true,
  tokenVerification: 'verified',
  decimals: 18,
  symbol: 'NEOK',
  logo: 'https://imagedelivery.net/lPzngbR8EltRfBOi_WYaXw/fb41c839-301b-460a-6f06-9f2714e25d00/public',
  name: 'NEOKingdom DAO',
  coinGeckoId: '',
  channelId: 'channel-83',
  source: 'cosmos',
  path: 'transfer/channel-83',
  baseDenom: 'erc20/0x655ecB57432CC1370f65e5dc2309588b71b473A9',
  hash: 'F6CC233E5C0EA36B1F74AB1AF98471A2D6A80E2542856639703E908B4D93E7C4',
  denom: 'ibc/F6CC233E5C0EA36B1F74AB1AF98471A2D6A80E2542856639703E908B4D93E7C4',
  tokenType: 'ibc',
  externalLogo: 'neok.png'
}

export const disabledEvmosTokens = [
  ...(neokTokenMeta
    ? [
        {
          ...neokTokenMeta,
          denom: `ibc/${neokTokenMeta.hash || ''}`
        }
      ]
    : [])
] as TokenStatic[]

export const injForeignBaseDenomMap = {
  [Network.Osmosis]:
    'ibc/64BA6E31FE887D66C6F8F31C7B1A80C7CA179239677B4088BB55F5EA07DBE273',
  [Network.Crescent]:
    'ibc/5A76568E079A31FA12165E4559BA9F1E9D4C97F9C2060B538C84DCD503815E30',
  [Network.Persistence]:
    'ibc/D64E84758BCA42602C27E9ED2DB8F4EFDAE6A1E311CF404B516D45FEDF319D73',
  [Network.Stride]:
    'ibc/A7454562FF29FE068F42F9DE4805ABEF54F599D1720B345D6518D9B5C64EA6D2',
  [Network.Migaloo]:
    'ibc/1C2D8505A29823310B4484E4C63CFDCB08C0D3B57537A615A45F4E5D42CDC789'
} as Record<Network, string>

export const injForeignBaseDenomChainIdMap = {
  [CosmosChainIds.Osmosis]:
    'ibc/64BA6E31FE887D66C6F8F31C7B1A80C7CA179239677B4088BB55F5EA07DBE273',
  [CosmosChainIds.Crescent]:
    'ibc/5A76568E079A31FA12165E4559BA9F1E9D4C97F9C2060B538C84DCD503815E30',
  [CosmosChainIds.Persistence]:
    'ibc/D64E84758BCA42602C27E9ED2DB8F4EFDAE6A1E311CF404B516D45FEDF319D73',
  [CosmosChainIds.Stride]:
    'ibc/A7454562FF29FE068F42F9DE4805ABEF54F599D1720B345D6518D9B5C64EA6D2',
  [CosmosChainIds.Migaloo]:
    'ibc/1C2D8505A29823310B4484E4C63CFDCB08C0D3B57537A615A45F4E5D42CDC789'
} as Record<string, string>

export const wethToken = {
  address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  isNative: true,
  tokenVerification: 'verified',
  decimals: 18,
  symbol: 'wETH',
  logo: 'https://imagedelivery.net/lPzngbR8EltRfBOi_WYaXw/a8d72344-01e4-4471-3098-2fd58f179b00/public',
  coinGeckoId: 'ethereum',
  name: 'Wrapped Ethereum',
  denom: 'peggy0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  tokenType: 'erc20',
  externalLogo: 'ethereum.png'
}

export const ethNativeToken = {
  decimals: 18,
  symbol: 'ETH',
  logo: wethToken?.logo || '',
  coinGeckoId: 'ethereum',
  name: 'Ether',
  address: '',
  tokenType: TokenType.Erc20,
  denom: 'eth',
  tokenVerification: TokenVerification.Verified,
  isNative: true,
  source: TokenSource.Ethereum
} as TokenStatic

export const solToken = {
  decimals: 6,
  symbol: 'SOL',
  name: 'SOL',
  logo: 'https://imagedelivery.net/lPzngbR8EltRfBOi_WYaXw/6f015260-c589-499f-b692-a57964af9900/public',
  coinGeckoId: '',
  denom: 'factory/inj1a4hvejdwaf9gd9rltwftxf0fyz6mrzwmnauacp/SOL',
  address: 'factory/inj1a4hvejdwaf9gd9rltwftxf0fyz6mrzwmnauacp/SOL',
  tokenType: 'tokenFactory',
  tokenVerification: TokenVerification.Verified,
  externalLogo: 'unknown.png'
} as TokenStatic
